import React from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div className="space-y-20">
      {/* Hero Section */}
      <section className="text-center space-y-6 py-12">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold">
          <span className="gradient-text">Cloud-Native Solutions</span>
          <br />
          <span className="text-slate-900">for the Digital Age</span>
        </h1>
        <p className="text-slate-600 text-lg max-w-2xl mx-auto">
          We craft next-generation software solutions that empower businesses 
          to thrive in an interconnected world.
        </p>
        <div className="flex items-center justify-center gap-4">
          <Link to="/softwares" className="btn-primary">
            Explore Our Products
          </Link>
          <a href="mailto:contact@aecloudsystem.com" className="btn-secondary">
            Get in Touch
          </a>
        </div>
      </section>

      {/* Stats Section */}
      <section className="grid grid-cols-2 md:grid-cols-4 gap-8">
        {[
          { label: 'Cloud-Native', value: '100%' },
          { label: 'Client Satisfaction', value: '99%' },
          { label: 'Uptime SLA', value: '99.99%' },
          { label: 'Response Time', value: '<500ms' }
        ].map((stat, i) => (
          <div key={i} className="text-center space-y-2">
            <div className="text-3xl font-bold gradient-text">{stat.value}</div>
            <div className="text-slate-600">{stat.label}</div>
          </div>
        ))}
      </section>

      {/* Features Grid */}
      <section className="grid sm:grid-cols-3 gap-6">
        {[
          {
            title: 'Cloud Architecture',
            description: 'Scalable, resilient, and secure cloud-native architectures built for the future.',
            icon: '🚀'
          },
          {
            title: 'Modern Tech Stack',
            description: 'Cutting-edge technologies and frameworks that power innovation.',
            icon: '⚡'
          },
          {
            title: 'AI Integration',
            description: 'Smart solutions enhanced with machine learning capabilities.',
            icon: '🤖'
          }
        ].map((feature, i) => (
          <div key={i} className="glass-card group">
            <div className="text-4xl mb-4 group-hover:scale-110 transition-transform">
              {feature.icon}
            </div>
            <h3 className="text-xl font-semibold text-slate-900 mb-2">
              {feature.title}
            </h3>
            <p className="text-slate-600">
              {feature.description}
            </p>
          </div>
        ))}
      </section>

      {/* CTA Section */}
      <section className="glass-card text-center space-y-6">
        <h2 className="text-3xl font-bold text-slate-900">
          Ready to Transform Your Business?
        </h2>
        <p className="text-slate-600 max-w-2xl mx-auto">
          Join forward-thinking companies leveraging our cloud expertise 
          to drive innovation and growth.
        </p>
        <div className="flex items-center justify-center gap-4">
          <Link to="/softwares" className="btn-primary">
            View Solutions
          </Link>
          <a href="mailto:contact@aecloudsystem.com" className="btn-secondary">
            Schedule Demo
          </a>
        </div>
      </section>
    </div>
  );
};

export default Home;